import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import UI from '../ui';
import Utils from '../utils';

const { Link } = UI;

const { Session } = Utils;

export const LegalList = () => {
	return (
		<div className="common-terms legal-list">
			<h2 className="terms-title">Legal Terms</h2>
			<div className="terms-list">
				<ul>
					<li>
						<RouteLink
							to="/terms/WebClient"
							dataqa="legal-webclient-terms-link"
						>
							Stamps.com Web Client Terms of Use
						</RouteLink>
					</li>
					<li>
						<RouteLink to="/terms/General" dataqa="legal-service-terms-link">
							Stamps.com Service Terms and Conditions
						</RouteLink>
					</li>
					<li>
						<Link
							href="https://auctane.com/legal/privacy-policy/"
							dataqa="legal-privacy-policy-link"
						>
							Stamps.com Privacy Policy
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
};
